import ParksCms from '@/pages/cms/ParksCms'
import AboutCms from '@/pages/cms/AboutCms'
import CompaniesCms from '@/pages/cms/CompaniesCms'

const routes = [
  {
    path: '/parks-cms',
    name: 'ParksCms',
    component: ParksCms,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/about-cms',
    name: 'AboutCms',
    component: AboutCms,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/companies-cms',
    name: 'CompaniesCms',
    component: CompaniesCms,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/cms.js